module.exports = __webpack_public_path__ + "img/official.0f255853.jpg";